<template>
  <div class="home">
    <div :class="{ header: true, totop: isTop }">
      <div class="header-warp">
        <div class="logo">
          <el-image class="logoImg" src="https://zhengxin-pub.bj.bcebos.com/logopic/e3c4ee6f055597028cb040e3bdc5bc50_fullsize.jpg" fit="cover"></el-image>
        </div>
        <div class="nav">
          <el-menu :default-active="activeIndex" class="meuns" mode="horizontal" background-color="#ffffff" text-color="#333333" active-text-color="#ff9800">
            <el-menu-item index="1">主页</el-menu-item>
            <el-menu-item index="2">公司介绍</el-menu-item>
            <el-menu-item index="3">产品信息</el-menu-item>
            <el-menu-item index="4">荣誉证书</el-menu-item>
          </el-menu>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="banner">
        <div class="swiper-container banner-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in bannerImg" :key="item">
              <img style="width: 100%; height: 100%; object-fit: cover;" :src="item" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
      <div class="product">
        <div class="product-title">
          <h3>产品内容</h3>
          <p>Product content</p>
          <router-link class="tip" to="#">更多内容>>></router-link>
        </div>
        <div class="product-list">
          <div class="list-left">
            <el-image style="width: 100%; height: 100%;" src="https://img.zcool.cn/community/01f9fe597987f9a8012193a337d8b6.jpg@3000w_1l_0o_100sh.jpg" fit="cover"></el-image>
          </div>
          <div class="list-right">
            <div class="item1">
              <el-image style="width: 100%; height: 260px;" src="https://img.zhisheji.com/bbs/forum/201807/04/164609e3pd8qzmfmrvhp8s.jpg" fit="cover"></el-image>
            </div>
            <div class="item2">
              <el-image style="width: 100%; height: 260px;" src="https://img.zcool.cn/community/01c3955e50b6dca8012165186cc527.jpg@2o.jpg" fit="cover"></el-image>
            </div>
          </div>
        </div>
      </div>
      <div class="certificate">
        <div class="certificate-title">
          <h3>荣誉证书</h3>
          <p>Certificate of honor</p>
          <router-link class="tip" to="#">更多内容>>></router-link>
        </div>
        <div class="swiper-container certificate-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="item in bannerImg2" :key="item">
              <img style="width: 300px; height: 360px; object-fit: cover;" :src="item" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data () {
    return {
      isTop: false,
      activeIndex: '1',
      bannerImg: [
        'https://image.jobcn.com/companyimages/imges/60/15/601549_15904851618341P8T.jpg',
        'https://image.jobcn.com/companyimages/imges/52/78/527874_15741427377701P8T.jpg',
        'https://p2.itc.cn/images01/20210421/dfd5583541f443f08b7281c89cd68d61.jpeg',
      ],
      bannerImg2: [
        require('@/assets/webImg/4.jpg'),
        require('@/assets/webImg/5.jpg'),
        require('@/assets/webImg/6.jpg'),
        require('@/assets/webImg/7.jpg'),
        require('@/assets/webImg/8.jpg')
      ]
    }
  },
  updated () {
    new Swiper(".swiper-container", {
      loop: true,
      autoplay: {
        disableOnInteraction: false,
      },
      speed: 600,
      parallax: true,
      effect: 'fade',
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  },
  mounted () {
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed () {
    window.removeEventListener("scroll", this.scrollToTop, true);
  },
  methods: {
    scrollToTop () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      //为了计算距离顶部的高度，当高度大于50显示回顶部图标，小于50则隐藏
      if (scrollTop > 60) {
        console.log("页面滚动超过60了");
        this.isTop = true;
      } else {
        console.log("页面没有超过50");
        this.isTop = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.home {
  width: 100%;
  height: 100%;
  overflow: hidden;

  .header {
    width: 100%;
    height: 80px;
    background-color: #ffffff;
    box-shadow: 0px 3px 5px #e5e5e5;

    .header-warp {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;

      .logo {
        width: 200px;
        height: 80px;

        .logoImg {
          width: 200px;
          height: 80px;
        }
      }

      .nav {
        width: 1000px;
        height: 80px;

        .meuns {
          width: 100%;
          overflow: hidden;
          border-bottom: none;
          display: flex;
          justify-content: right;

          .el-menu-item {
            height: 80px;
            line-height: 80px;
            font-size: 18px;
          }
        }
      }
    }
  }

  .totop {
    position: fixed;
    top: 0;
    z-index: 999;
  }

  .content {
    width: 100%;
    overflow: hidden;

    .banner {
      width: 1200px;
      height: 580px;
      margin: 10px auto;

      .banner-swiper {
        width: 1200px;
        height: 580px;
      }
    }

    .product {
      width: 100%;
      height: 680px;
      display: flex;
      flex-direction: column;

      .product-title {
        width: 1200px;
        padding: 10px 0;
        text-align: center;
        margin: 0 auto;
        position: relative;

        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          font-size: 18px;
        }

        .tip {
          position: absolute;
          top: 10px;
          right: 0;
          font-weight: bolder;
        }
      }

      .product-list {
        width: 1000px;
        height: 100%;
        margin: 0 auto;
        display: flex;

        .list-left {
          width: 580px;
          height: 560px;
          border-radius: 10px;
          overflow: hidden;
          margin-right: 20px;
          background: rgb(150, 160, 95);
        }

        .list-right {
          width: 580px;
          height: 560px;
          margin-left: 20px;

          .item1 {
            width: 100%;
            height: 260px;
            border-radius: 10px;
            overflow: hidden;
            margin-bottom: 40px;
            background: palevioletred;
          }

          .item2 {
            width: 100%;
            height: 260px;
            border-radius: 10px;
            overflow: hidden;
            background: violet;
          }
        }
      }
    }

    .certificate {
      width: 100%;
      height: 550px;

      .certificate-title {
        width: 1200px;
        padding: 10px 0;
        text-align: center;
        margin: 0 auto;
        position: relative;

        h3 {
          font-size: 24px;
          margin-bottom: 10px;
        }

        p {
          font-size: 18px;
        }

        .tip {
          position: absolute;
          top: 10px;
          right: 0;
          font-weight: bolder;
        }
      }

      .certificate-swiper {
        width: 1200px;
        height: 400px;
        overflow: hidden;

        .swiper-slide {
          width: 300px;
          height: 360px;
          display: flex;
          justify-content: center;
        }
      }
    }
  }

  .parallax-bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 130%;
    height: 100%;
    background-size: cover;
    background-position: left;
    background-image: url("../../../assets/webImg/5.jpg");
  }

  .title {
    margin-bottom: 10px;
    font-size: 24px;
    font-weight: bold;
  }

  .subtitle {
    margin-bottom: 10px;
    font-size: 18px;
  }

  .text {
    max-width: 430px;
    line-height: 1.32;
  }
}
</style>